export default {
    'statistic-type': 'Statistic type',
    'final-accounts': 'Final accounts',
    'custom-statements': 'Custom statements',
    'accounts-summary': 'Accounts summery',
    'earnings-and-loss-chart': 'Earnings and loss chart'
}